// Lecture complète d'une table, par tranches.
//
// PostgREST plafonne le nombre de lignes qu'il rend (PGRST_DB_MAX_ROWS, souvent
// 1 000) et NE SIGNALE PAS la troncature : la requête réussit, il en manque.
// Sur des chiffres d'argent, c'est le pire des défauts — le relevé bancaire
// 2026 compte à lui seul 1 080 mouvements, et un solde calculé sur les 1 000
// premiers serait faux sans le moindre message.
//
// D'où cette lecture par tranches : on redemande tant qu'une tranche revient
// pleine. Une tranche incomplète prouve qu'on a tout lu.

/** Taille d'une tranche. En dessous du plafond usuel, pour ne jamais le heurter. */
const TRANCHE = 500;

/** Garde-fou : au-delà, c'est une boucle qui ne s'arrête pas, pas un gros volume. */
const TRANCHES_MAX = 200;

export interface ReponsePage<T> {
  data: T[] | null;
  error: { message: string } | null;
}

/**
 * Lit toutes les lignes d'une requête, quelle que soit leur nombre.
 *
 * `page` reçoit les bornes d'une tranche (incluses) et doit rendre la requête
 * correspondante — typiquement `requete().range(de, a)`.
 */
export async function lireTout<T>(
  page: (de: number, a: number) => PromiseLike<ReponsePage<T>>,
): Promise<T[]> {
  const tout: T[] = [];
  for (let i = 0; i < TRANCHES_MAX; i += 1) {
    const de = i * TRANCHE;
    const { data, error } = await page(de, de + TRANCHE - 1);
    if (error) throw new Error(error.message);
    const lot = data ?? [];
    tout.push(...lot);
    if (lot.length < TRANCHE) return tout;
  }
  throw new Error(
    `Lecture interrompue au-delà de ${String(TRANCHE * TRANCHES_MAX)} lignes : ` +
      'volume inattendu, à vérifier avant de se fier au résultat.',
  );
}
